import AnalyticsContainer from "./containers/AnalyticsContainer";
import "./styles.scss";
export default AnalyticsContainer;
